import type { CSSProperties } from 'react';
import type { NavbarMenuListGroupElementProps } from '../../navbarElement/Navbar.type';
import { cn } from '../../utils/cn';
import * as styles from '../Navbar.css';
import { useNavbarMenuListV2Context } from './context';

export function NavbarMenuListGroupV2(props: NavbarMenuListGroupElementProps) {
  const { element, className, children, style, attributes } = props;
  const { type, customAttributes } = element.attrs || {};

  const { justify } = useNavbarMenuListV2Context();

  if (type === 'left') {
    return (
      <div
        {...props}
        {...attributes}
        {...customAttributes}
        className={cn(justify !== 'start' && 'flex-1', styles.navbarMenuListGroupV2, styles.alignLeftV2, className)}
        style={
          {
            '--min-height': 'var(--height)',
            ...style,
          } as CSSProperties
        }
      >
        {children}
      </div>
    );
  }

  if (type === 'middle') {
    return (
      <div
        {...props}
        {...attributes}
        {...customAttributes}
        style={
          {
            ...style,
            '--min-height': 'var(--height)',
          } as CSSProperties
        }
        className={cn('hidden md:flex shrink-0', styles.navbarMenuListGroupV2, styles.alignCenterV2, className)}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      {...props}
      {...attributes}
      {...customAttributes}
      className={cn(justify !== 'end' && 'flex-1', styles.navbarMenuListGroupV2, styles.alignRightV2, className)}
      style={
        {
          '--min-height': 'var(--height)',
          ...style,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
}
